/* eslint-disable tailwindcss/no-custom-classname */
import React, {useEffect, useState} from 'react'
import dynamic from 'next/dynamic'
import Slider from '@ant-design/react-slick'
import { useDeviceType } from '@frontastic/catwalk/src/js/helper/hooks/useDeviceType'
import PropTypes from 'prop-types'
import styles from "./ProductImages.module.css"
import FrontasticImage from '../../../atoms/frontasticImage'
const DemoUpButton = dynamic(() => import('demoup-react').then((mod) => mod.default('sport2000.de').button), { ssr: false })


const IMAGE_SIZE_ON_DESKTOP = 1000
const IMAGE_SIZE_ON_MOBILE = 400

const ProductImages = ({images, title}) => {
    const [nav1, setNav1] = useState(null)
    const [nav2, setNav2] = useState(null)
    const [isClient, setIsClient] = useState(false)
    const isMobile = useDeviceType() === 'mobile';
    const [renderAgain, setRenderAgain] = useState(new Date().getTime());
    const VideoButton = <DemoUpButton
      className = {styles.button} // Add a class to the button container. Default is "demoup-trigger"
      buttonheight = {8} // Overwrite the height of play image. Default is set by DemoUp specific for each shop.
      buttonwidth = {8} // Overwrite the width of play image. Default is set by DemoUp specific for each shop.
      color = "#FFF" // Overwrite the color of the play image in the button. Default is set by DemoUp specific for each shop.
      height = {200} // Overwrite the height of the button container in pixels. Default is set by DemoUp specific for each shop.
      multibutton = {false} // Should multiple videos displayed as one or several buttons behind each other? true/false Default: false
      width = {200} // Overwrite the width of the button container in pixels. Default is set by DemoUp specific for each shop.
      mode = "production" // If not set the component will detect "Node.env" environment variable and choose to either load the local/staging or production version. By default this is staging. To overwrite this detection use this parameter to explicitly set the system into production mode.
    />;
    const [hasDemoUpVideoButton, setHasDemoUpVideoButton] = useState(false);

    
    const settingsMain = {
        dots: true,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        lazyLoad: isClient ? "ondemand" : false,
        appendDots: (dots) => (
          <div style={{ display: "flex", justifyContent: "center" }}>
            {dots.map((dot, index) => (
              <React.Fragment key={index}>
                {
                  index === 1 && hasDemoUpVideoButton ? (
                    React.cloneElement(dot, {
                      className: `playDot ${dot.props.className}`,
                    })
                  ) : dot
                }
              </React.Fragment>
            ))}
          </div>
        ),
    }

    const settingsThumbs = {
        slidesToScroll: 1,
        slidesToShow: 4,
        infinite: false,
        dots: false,
        swipeToSlide: true,
        focusOnSelect: true,
        variableWidth: true,
        lazyLoad: isClient ? "ondemand" : false,
    }

    useEffect(() => {
      const interval = setInterval(() => {
        if (window.DemoUpPlaybuttonRenderer) {
          setRenderAgain(Date.now());
          clearInterval(interval); 
        }
      }, 100);
  
      return () => clearInterval(interval);
    }, []);
  
    useEffect(() => {
        setIsClient(true)
    }, [])

    const imageWidth = isMobile ? IMAGE_SIZE_ON_MOBILE : IMAGE_SIZE_ON_DESKTOP
    const imageHeight = isMobile ? IMAGE_SIZE_ON_MOBILE : IMAGE_SIZE_ON_DESKTOP

    const youtubeUrl = 'youtube-nocookie'

    const renderProductImage = (width, height, isThumbnail = false) => {
      let imagesCopy = [...images];
      imagesCopy = images.map((image, index) => {
        const checkVideoOrImage = images.filter((item) => item.includes(youtubeUrl));
  
        return (
          <div className="product-article-image" key={`${image} + ${index}`}>
              {checkVideoOrImage.length > 0 && images.length - 1 === index ? (
                  <div className={'product-video-item'}>
                      <iframe
                          data-cmp-vendor={'s30'}
                          src={'about:blank'}
                          className={'cmplazyload'}
                          width={'100%'}
                          height={'100%'}
                          data-cmp-src={checkVideoOrImage}
                          frameBorder={'0'}
                          allow={'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture'}
                          allowFullScreen
                          title={'Embedded youtube'}
                      />
                  </div>
              ) : (
                  <div className="product-article-img">
                      {(!isClient && index === 0) && (
                          <FrontasticImage
                              src={image}
                              width={width}
                              height={height}
                              alt={title}
                              priority={index === 0}
                          />
                      )}
                      {isClient &&
                          <FrontasticImage
                              src={image}
                              width={width}
                              height={height}
                              alt={title}
                              priority={index === 0}
                          />
                      }
                  </div>
              )}
          </div>
        );
      });
      if (hasDemoUpVideoButton) {
        imagesCopy.splice(1, 0, (
          <div className={'product-article-image'} key={`video-test`}>
            <div className={'productDemoUpButtonWrap'}>
              {VideoButton}
          </div>
        </div>
        ));
      }
      return imagesCopy
    }


    if (!images || !images.length) {
        return null
    }

    return (<div key={`abc-${renderAgain}`} className={`product-detail-image ${styles.wrap}`}>
        {/* Main Product Slider */}
        <Slider {...settingsMain} asNavFor={nav2} ref={(slider1) => setNav1(slider1)}>
            {renderProductImage(imageWidth, imageHeight)}
        </Slider>


        {/* Thumbnail Slider */}
        <div className={'thumbnail-slider-wrap'}>
            <Slider {...settingsThumbs} asNavFor={nav1} ref={(slider2) => setNav2(slider2)}>
                {renderProductImage(120, 120)}
            </Slider>
        </div>
        <div className={styles.hiddenVideoButton}>
        <DemoUpButton
          className = {styles.button} // Add a class to the button container. Default is "demoup-trigger"
          buttonheight = {8} // Overwrite the height of play image. Default is set by DemoUp specific for each shop.
          buttonwidth = {8} // Overwrite the width of play image. Default is set by DemoUp specific for each shop.
          color = "#FFF" // Overwrite the color of the play image in the button. Default is set by DemoUp specific for each shop.
          height = {200} // Overwrite the height of the button container in pixels. Default is set by DemoUp specific for each shop.
          multibutton = {false} // Should multiple videos displayed as one or several buttons behind each other? true/false Default: false
          width = {200} // Overwrite the width of the button container in pixels. Default is set by DemoUp specific for each shop.
          mode = "production" // If not set the component will detect "Node.env" environment variable and choose to either load the local/staging or production version. By default this is staging. To overwrite this detection use this parameter to explicitly set the system into production mode.
          onVideoAvailable={() => {
            setHasDemoUpVideoButton(true);
          }}
        />;
      </div>
    </div>)
}

ProductImages.propTypes = {
    images: PropTypes.array.isRequired, title: PropTypes.string.isRequired,
}

export default ProductImages
